export function parseXMPMetaData(xmpMetaData) {
  const metadata = {};
  const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
  if (tags) {
    tags.forEach(tag => {
      const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
      if (match) {
        const name = match[2];
        metadata[name] = match[3];
      }
    });
  }
  return metadata;
}